import * as React from 'react'

import { Box } from '@factorialco/deprecated-design-system'
import type { Form } from 'factorial-form'
import pullAt from 'lodash/pullAt'

import IconButton from './IconButton'
import Input from './Input'

export interface Option {
  label: string
  is_active: boolean
  draft: boolean
  index: number
}
interface Props {
  option: Option
  disabled: boolean
  form: Form
}

const OptionRow = ({ option, disabled, form }: Props) => {
  const onChange = (value: unknown) => {
    const optionsFormData = form.data().choice_options
    const options = form.get('choice_options')
    optionsFormData[option.index] = {
      label: value,
      is_active: true,
      draft: true,
    }
    options.set(optionsFormData)
  }

  const deleteHandler = () => {
    const optionsFormData = form.data().choice_options
    const options = form.get('choice_options')
    pullAt(optionsFormData, [option.index])
    options.set(optionsFormData)
  }

  const archiveHandler = () => {
    const optionsFormData = form.data().choice_options
    const options = form.get('choice_options')

    const updatedOptions = optionsFormData.map((optionFormData: any, indexInOptions: any) => {
      if (indexInOptions !== option.index) return optionFormData

      optionFormData.is_active = !option.is_active

      return optionFormData
    })
    options.set(updatedOptions)
  }

  const archived = !option.is_active

  return (
    <>
      <Box flexDirection="row" justifyContent="spaceBetween" alignItems="flexStart">
        <Input
          label={option.label}
          disabled={disabled}
          onChange={onChange}
          archived={archived}
          draft={option.draft}
        />
        <Box paddingLeft="s8" paddingTop="s8">
          <IconButton
            disabled={disabled}
            archived={archived}
            draft={option.draft}
            archiveHandler={archiveHandler}
            deleteHandler={deleteHandler}
          />
        </Box>
      </Box>
    </>
  )
}

export default OptionRow
